
import { commonApi, filter } from "@/common/index";
import dateFormat from 'vux/src/tools/date/format.js'
import Group from 'vux/src/components/group/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

import noData from "@/common/components/noData/index.vue";
import {
resetTextBylangKey,
dateSelectedOptions,
} from "../../../libs/options.js";
import loadMore from "@/common/components/load-more/index.vue";

import { parseTime, toTimestamp } from "@/common/utils/Date.js";

var allBalanceInfo = {
totalCount: 0.0,
totalBetAmount: 0.0,
totalBetflow: 0.0,
totalResultAmount: 0.0,
};
export default {
directives: { TransferDom },
filters: {
timeFilter(time) {
return parseTime(time);
},
moneyFilter(money = 0) {
return (+money).toFixed(2);
},
getMoney(bets) {
const arr = bets.map((item) => {
return item.odds;
});
let sum = 0;
arr.forEach(function (val, index, arr) {
sum += Number(val);
});
return (+sum).toFixed(2);
},
gameTypeFilter(gameType) {
return filter.gameType(gameType);
},
},
components: {
XButton,
Flexbox,
FlexboxItem,
TransferDom,
Popup,
Divider,
Group,
Datetime,
noData,
loadMore,
},
data() {
return {
finish: null, // 结束加载动画
pages: {
pageNo: 1,
pageSize: 7,
},
total: null,
queryParams: {
startTime: "",
endTime: "",
gameType: -1,
platformCode: -1,
},
days: "30",
customTime: false, // 自定义时间是否显示
searchShow: false, // 搜索显示
balanceList: [],
allBalanceInfo: Object.assign({}, allBalanceInfo),
isShowMedal: false,
dataInfoDetail: null,
};
},
computed: {
selectionTimeOptions() {
return resetTextBylangKey(
dateSelectedOptions,
this.$t("mine").timeOptions
);
},
selectionType() {
let list = JSON.parse(JSON.stringify(this.$store.state.jinGameTypes));
list.map((item) => (item.langKey = item.id));
list = resetTextBylangKey(
list,
this.$t("mine").betRecord.gamelist,
"offerTypeName"
);
return list;
},
},
created() {
this._getLists();
},
methods: {
myBalanceList(item) {
if (item.gameType == 3 && item.strAttr1) {
this.dataInfoDetail = { ...item, ...JSON.parse(item.strAttr1) };
this.isShowMedal = true;
}
},
statusFilter(status) {
return this.$t(filter.gameHistoryStatus(status));
},
_conditionSelected(str, val) {

if (str === "gameType") this.queryParams[str] = val;
if (str === "days") {
this.customTime = false;
this.days = val;
}
},

_refresh({ finish }) {

this.finish = finish;
this.pages.pageNo = 1;
this._getLists();
},

_loadmore({ finish }) {

this.finish = finish;
if (this.balanceList.length === this.total) {
this.$vux.toast.show({
text: this.$t("others").noData1,
type: "cancel",
});
this.finish();
return;
}
this.pages.pageNo += 1;
this._getLists();
},

handleCustomTime() {

this.customTime = true;
this.days = null;
this.queryParams.startTime = "";
this.queryParams.endTime = "";
},

setStartTime() {},
setEndTime() {},


_Search() {
this.pages.pageNo = 1;
const { startTime, endTime } = this.queryParams;
if (
!this.days &&
(startTime === "" ||
endTime === "" ||
(startTime !== "" && endTime !== "" && startTime >= endTime))
) {
this.$vux.toast.show({
text: this.$t("mine").betRecord.timeError,
type: "cancel",
});
return;
}
this.searchShow = false;
this.balanceList = [];
this.$store.commit("updateLoadingStatus", { isLoading: true });
if (this.$refs.loadMoreEle) this.$refs.loadMoreEle.scrollToTop();
this._getLists();
},

_getLists() {

const { startTime, endTime, platformCode, gameType } = this.queryParams;
const params = {
platformCode,
gameType,
UUID: this.$store.state.UUID,
...this.pages,
};
if (!this.days) {
params.startTime = toTimestamp(startTime);
params.endTime = toTimestamp(endTime);
} else {
const nowTime = new Date().getTime();
params.endTime = toTimestamp(nowTime);
params.startTime = toTimestamp(
nowTime - 60 * 60 * 1000 * 24 * this.days
);
}
commonApi.WALLET.newgameHistory(params)
.then((data) => {
const { list, total } = data.pageInfo;
this.total = total;
this.balanceList =
this.pages.pageNo === 1
? data.pageInfo.list
: [...this.balanceList, ...data.pageInfo.list];
this.allBalanceInfo = data;
if (this.finish) this.finish();
this.$store.commit("updateLoadingStatus", { isLoading: false });
})
.catch((err) => {
if (this.pages.pageNo === 1) {
this.total = 0;
this.balanceList = [];
}
this.allBalanceInfo = Object.assign({}, allBalanceInfo);
if (this.finish) this.finish();
this.$store.commit("updateLoadingStatus", { isLoading: false });
});
},

onCopySuccess() {
this.$vux.toast.show({
text: this.$t("others.copySuceess"),
type: "success",
});
},
onCopyError() {
this.$vux.toast.show({
text: "复制失败",
type: "cancel",
});
},
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/BetRecord/index.vue